/*
 * MessageConstants
 * These are the variables that contain the text which is displayed on certain errors
 *
 * Follow this format:
 * export const YOUR_CONSTANT = 'Your message text';
 */
export const FIELD_MISSING = 'Please fill out the entire form.';
export const UNAUTHORIZED = 'Usuario o contraseña incorrectos';
export const UNAUTHORIZED_TOKEN = 'No tiene autorización';
export const SESSION_EXPIRED =
  'Su sesión expiró. Vuelva a iniciar sesión para continuar.';
export const WRONG_PASSWORD = 'Wrong password.';
export const USER_NOT_FOUND = 'This username does not exist.';
export const USERNAME_TAKEN = 'Sorry, but this username is already taken';
export const GENERAL_ERROR =
  'Ha ocurrido un error inesperado. Si el error continua contáctese con el administrador del sistema.';
